
.option {
  & + & {
    margin-top: .5em;
  }
}

.visible-checkbox--on-color {
  border-color: transparent !important; // override global style
  border-width: 4px !important; // override global style
}
